{
  "name": "bolt-v2",
  "version": "1.0.23",
  "scripts": {
    "ng": "ng",
    "start": "graphql-codegen --verbose && graphql-codegen --config mesh-codegen.ts --verbose && ng serve --port 4200 --hmr=true --live-reload=true",
    "serve": "node --max_old_space_size=4096 ./node_modules/@angular/cli/bin/ng s",
    "build": "ng build",
    "watch": "ng build --watch --configuration dev",
    "test": "ng test",
    "predev": "graphql-codegen --verbose && graphql-codegen --config mesh-codegen.ts --verbose"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.1.4",
    "@angular/cdk": "^20.1.4",
    "@angular/common": "^20.1.4",
    "@angular/compiler": "^20.1.4",
    "@angular/core": "^20.1.4",
    "@angular/fire": "20.0.1",
    "@angular/forms": "^20.1.4",
    "@angular/platform-browser": "^20.1.4",
    "@angular/platform-browser-dynamic": "^20.1.4",
    "@angular/router": "^20.1.4",
    "@apollo/client": "^3.11.8",
    "@fortawesome/fontawesome-free": "^6.7.1",
    "@graphql-typed-document-node/core": "^3.2.0",
    "@ngrx/effects": "^20.0.0",
    "@ngrx/entity": "^20.0.0",
    "@ngrx/router-store": "^20.0.0",
    "@ngrx/store": "^20.0.0",
    "@ngrx/store-devtools": "^20.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@primeng/themes": "^20.0.0",
    "@sentry/angular": "^9.9.0",
    "@tmcw/togeojson": "^7.1.0",
    "@turf/area": "^7.2.0",
    "@turf/helpers": "^7.2.0",
    "@turf/length": "^7.2.0",
    "@types/graphql": "^14.2.3",
    "@types/jasmine": "~5.1.0",
    "@types/leaflet": "^1.9.14",
    "@types/leaflet.markercluster": "^1.5.5",
    "@xmldom/xmldom": "^0.9.8",
    "apollo-angular": "^11.0.0",
    "axios": "^1.7.9",
    "country-state-city": "^3.2.1",
    "crypto-js": "^4.2.0",
    "date-fns": "^4.1.0",
    "exceljs": "^4.4.0",
    "file-saver": "^2.0.5",
    "firebase": "12.0.0",
    "graphql": "^16.9.0",
    "intl-tel-input": "^25.3.0",
    "jspdf": "^3.0.2",
    "jspdf-autotable": "^5.0.2",
    "jwt-decode": "^4.0.0",
    "leaflet": "^1.9.4",
    "leaflet-arrowheads": "^1.4.0",
    "leaflet-draw": "^1.0.4",
    "leaflet-editable": "^1.3.0",
    "leaflet-geosearch": "^4.2.0",
    "leaflet-path-transform": "^1.9.0",
    "leaflet-providers": "^2.0.0",
    "leaflet-rotatedmarker": "^0.2.0",
    "leaflet.gridlayer.googlemutant": "^0.15.0",
    "leaflet.heat": "^0.2.0",
    "leaflet.locatecontrol": "^0.82.0",
    "leaflet.markercluster": "^1.5.3",
    "leaflet.path.drag": "^0.0.6",
    "lmdb": "^3.4.1",
    "lodash.clonedeep": "^4.5.0",
    "lottie-web": "^5.13.0",
    "luxon": "^3.5.0",
    "moment": "^2.30.1",
    "moment-timezone": "^0.6.0",
    "ngrx-store-localstorage": "^20.0.0",
    "ngx-cookie-service": "^20.0.1",
    "ngx-json-viewer": "^3.2.1",
    "ngx-lottie": "^20.0.0",
    "ngx-scanner-qrcode": "^1.7.3",
    "paho-mqtt": "^1.1.0",
    "posthog-js": "^1.298.0",
    "primeflex": "^4.0.0",
    "primeicons": "^7.0.0",
    "primeng": "^20.0.1",
    "react": "^18.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.1.0",
    "xlsx": "^0.18.5",
    "zone.js": "~0.15.1"
  },
  "devDependencies": {
    "@angular/build": "^20.1.4",
    "@angular/cli": "^20.1.4",
    "@angular/compiler-cli": "^20.1.4",
    "@graphql-codegen/cli": "^5.0.3",
    "@graphql-codegen/client-preset": "^4.8.3",
    "@graphql-codegen/typescript": "^4.1.1",
    "@graphql-codegen/typescript-apollo-angular": "^4.0.1",
    "@graphql-codegen/typescript-operations": "^4.3.1",
    "@graphql-codegen/typescript-resolvers": "^4.4.0",
    "@types/file-saver": "^2.0.7",
    "@types/node": "^22.13.13",
    "autoprefixer": "^10.4.20",
    "jasmine-core": "~5.2.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "postcss": "^8.4.47",
    "tailwindcss": "^3.4.14",
    "typescript": "~5.8.3"
  }
}
